import { NgModule } from '@angular/core';
import { ListGroupItemDirective } from './wdx-list-group-item/wdx-list-group-item.directive';
import { ListGroupDirective } from './wdx-list-group/wdx-list-group.directive';

@NgModule({
    declarations: [ListGroupDirective, ListGroupItemDirective],
    exports: [ListGroupDirective, ListGroupItemDirective],
})
export class WdxListGroupModule {}
